import { MixedItem } from 'store/railsBuilder/reducer.types';

import { BtvProgramme, EventItemWithServiceInfo } from '../types';
import getRBChannelItemDetailsParams from './getRBChannelItemDetailsParams';
import parseParentalRating from './utils/parseParentalRating';

function parseRBChannelItemToMixedItem(
    item: EventItemWithServiceInfo,
): MixedItem {
    const event = item.currentEvent as BtvProgramme;

    return {
        id: event.id || '',
        type: event.type,
        contentType: event.editorial?.contentType,
        playbackType: event.playbackType,
        title: event.title || '',
        channelId: event.serviceRef,
        seriesId: event.editorial?.seriesRef,
        season: event.editorial?.SeasonNumber,
        episode: event.editorial?.episodeNumber,
        episodeTitle: event.editorial?.Episode,
        startTime: event.period?.start,
        endTime: event.period?.end,
        year: event.editorial?.Year,
        parentalRating: parseParentalRating(event),
        CUEndDate: event.CUEndDate,
        isCatchUp: event.isCatchUp,
        isStartOver: event.isStartOver,
        links: event.links,
        detailsPageParams: getRBChannelItemDetailsParams(item),
    };
}

export default parseRBChannelItemToMixedItem;
